
import { isSet, optionsToKeyValuePairs } from "../../../../../../utils/commonUtils";
import { computationRules1 } from "./DrugScreenCollection";
export const Audiogram = (props)=>{
    // console.log('props.lookupsOptions',props.lookupsOptions);
    const stackedFieldStyle = {
        layout: 'stacked',
        showContainerBorder: false,
        labelWrap: false,
        isLabel: true,
      };
    const charts = [{
        type:'Grid',
        col:'col-md-3',
        className: 'non-dot-exam-scrollable',
        style: {
            position: "sticky",
            top: "0",
            zIndex: "1",
            height: "calc(100vh - 200px)",
            overflowY: "auto",
            overflowX: "hidden"
        },
        data:[
            {
            type:"PatientDetails",
            employeeDetails:props.employeeDetails,
            visitDetails:props.visitDetails,
            },
            {
            type:"CompanyDetails",
            companyDetails:props.companyDetails
            },
      ],
     },
     {
        type:'Tab',
        col:'col-md-9',
        data:[
            {
                id:'history',
                label:'History',
                labelStyle: 'padding: 0;',
                data:[
                    {
                        label:'History',
                        labelStyle: 'fw-semibold',
                        fields:[
                            {
                                type: "Label",
                                layout: 'stacked',
                                label: '1. 14-Hour Quiet Period / Recent Loud Noise',
                                col: 'col-12 border-0',
                                isBold:true,
                                fontBold:'200',
                                appendClassLabel:'text-left text-black  fw-bold opacity-100',
                            },
                            {
                                label: "In The Last 14 Hours, Were You Exposed To Loud Noise Without Hearing Protection?",                                type: 'RadioGroup',
                                ...stackedFieldStyle,
                                name: 'exposed_to_loud_noise_14_hours',
                                id: 'exposed_to_loud_noise_14_hours',
                                options: [
                                  { label: 'Yes', value: 'Yes' },
                                  { label: 'No', value: 'No' },
                                ],
                                col: 'col-12 border-0 ',
                                appendClassLabel:'font-weight-semibold',
                            },
                            {
                                label:"",
                                type:"TextInput",
                                ...stackedFieldStyle,
                                placeholder:"Describe",
                                name: 'loud_noise_description_14_hours',
                                id: 'loud_noise_description_14_hours',
                                col: 'col-12 border-0 ',
                                appendClassLabel:'font-weight-semibold',
                            },
                            {
                                type: "Label",
                                layout: 'stacked',
                                label: '2.Workplace Noise Exposure',
                                col: 'col-12 border-0',
                                isBold:true,
                                fontBold:'200',
                                appendClassLabel:'text-left text-black  fw-bold opacity-100',
                            },
                            {
                                label: "Are You Exposed To Loud Noise At Work (Machines, Tools, Engines, Etc.)?",                                type: 'RadioGroup',
                                ...stackedFieldStyle,
                                name: 'exposed_to_loud_noise_at_work',
                                id: 'exposed_to_loud_noise_at_work',
                                options: [
                                  { label: 'Yes', value: 'Yes' },
                                  { label: 'No', value: 'No' },
                                ],
                                col: 'col-12 border-0 ',
                                appendClassLabel:'font-weight-semibold',
                            },
                            {
                                type: "Label",
                                layout: 'stacked',
                                label: '3.Hearing Protection Typically Used at Work (If Exposed)',
                                col: 'col-12 border-0',
                                isBold:true,
                                fontBold:'200',
                                appendClassLabel:'text-left text-black  fw-bold opacity-100',
                            },
                            {
                                label:"",
                                type: 'RadioGroup',
                                ...stackedFieldStyle,
                                name: 'hearing_protection_type_at_work',
                                id: 'hearing_protection_type_at_work',
                                options: [
                                  { label: 'Earplugs', value: 'earplugs' },
                                  { label: 'Earmuffs', value: 'earmuffs' },
                                  { label: 'Both', value: 'both' },
                                  { label: 'None', value: 'none' },
                                ],
                                col: 'col-12 border-0 ',
                                appendClassLabel:'font-weight-semibold',
                            },
                            {
                                type: "Label",
                                layout: 'stacked',
                                label: "4.Today's Ear Status + Key Symptoms/History (Combined)",
                                col: 'col-12 border-0',
                                isBold:true,
                                fontBold:'200',
                                appendClassLabel:'text-left text-black  fw-bold opacity-100',
                            },
                            {
                                type:'AdulterationForm',
                                label: "Do You Have Any Of The Following Today Or Historically That May Affect Testing:",                                notes:['ear pain, drainage, pressure/fullness, dizziness','significant congestion/allergies/cold','suspected earwax blockage','ringing/buzzing (tinnitus)','trouble hearing / known hearing loss / hearing aids','past ear surgery/tubes, ruptured eardrum, frequent ear infections'],
                                appendClassLabel:'font-weight-semibold',
                            },
                            {
                                label:"",
                                type: 'RadioGroup',
                                ...stackedFieldStyle,
                                name: 'ear_status_symptoms_affect_testing',
                                id: 'ear_status_symptoms_affect_testing',
                                options: [
                                  { label: 'Yes', value: 'Yes' },
                                  { label: 'No', value: 'No' },
                                ],
                                col: 'col-12 border-0 ',
                                appendClassLabel:'font-weight-semibold',
                            },
                            {
                                label:"",
                                type:"TextInput",
                                ...stackedFieldStyle,
                                placeholder:"Describe",
                                name: 'ear_status_symptoms_description',
                                id: 'ear_status_symptoms_description',
                                col: 'col-12 border-0 ',
                                appendClassLabel:'font-weight-semibold',
                            },
    
                            {
                                type: "Label",
                                layout: 'stacked',
                                label: '5.Non-Work Loud Noise Exposure',
                                col: 'col-12 border-0',
                                isBold:true,
                                fontBold:'200',
                                appendClassLabel:'text-left text-black  fw-bold opacity-100',
                            },
                            {
                                label: "Do You Have Regular Or Recent Loud Noise Exposure Outside Of Work (Firearms, Loud Music/Headphones, Motorcycles, Power Tools, Loud Hobbies)?",                                type: 'RadioGroup',
                                ...stackedFieldStyle,
                                name: 'exposed_to_loud_noise_non_work',
                                id: 'exposed_to_loud_noise_non_work',
                                options: [
                                  { label: 'Yes', value: 'Yes' },
                                  { label: 'No', value: 'No' },
                                ],
                                col: 'col-12 border-0 ',
                                appendClassLabel:'font-weight-semibold',
                            },
                            {
                                label:"",
                                type:"TextInput",
                                ...stackedFieldStyle,
                                placeholder:"Describe",
                                name: 'loud_noise_description_non_work',
                                id: 'loud_noise_description_non_work',
                                col: 'col-12 border-0 ',
                                appendClassLabel:'font-weight-semibold',
                            },
                         ]
                    },
                     {
                    label:'Patient Signature & Comments',
                     labelStyle: "fw-semibold",
                    col:'col-12',
                    fields:[
                         {
                           label: 'Comments',
                           type: 'TextArea',
                           name: 'patient_comments',
                           id: 'patient_comments',
                           col: 'col-md-6 col-12 border-0',
                           layout: 'stacked',
                           labelStyle: { paddingLeft: '0.75rem' },
                           style: { minHeight: '150px', resize: 'vertical' },
                           rows: 5,
                         },
                         {
                           label: "Signature",
                           type: 'NewSignature',
                           isLabel: false,
                           col: 'col-md-6 col-12 border-0',
                           name: 'driver_signature',
                           id: 'driver_signature',
                           required: true,
                         },
                    ]
                },
                ]
            },
            {
                id:'exam',
                label:'Exam',
                labelStyle: 'padding: 0;',
                data:[
                    {   
                        label: 'Audiometric Readings (Frequency in Hz)',
                        labelStyle: 'fw-semibold',
                        fields: [
                            {
                                type: 'AudiogramTable',
                                label: 'Audiometric Readings (Frequency in Hz)',
                                col: 'col-12',
                            }
                        ]
                    },
                     {
                        hideHeader: true,
                        cardBodyClassName: 'p-0',
                        fields: [
                            {
                                type: 'TrialYesOrNoTable',
                                label: 'Otoscopic Evaluation (Optional)',
                                col: 'col-12',
                                options: [{ label: 'Yes', value: 1 }, { label: 'No', value: 0 }],
                                columns: [
                                    { label: 'Left', value: 'left' },
                                    { label: 'Right', value: 'right' }
                                ],
                                sections: [
                                    {
                                        rows: [
                                            { label: 'Ear canal clear?', nameBase: 'ear_canal_clear' },
                                            { label: 'Ear drum visible?', nameBase: 'ear_drum_visible' },
                                            { label: 'Inflammation/Obstruction?', nameBase: 'inflammation_obstruction'},
                                            { label: 'Scarring of the eardrum?', nameBase: 'scarring_of_the_eardrum' },
                                            { label: 'Drainage from the ear?', nameBase: 'drainage_from_the_ear' },
                                        ]
                                    },
                                ]
                            }
                        ]
                    },
                    {
                        label: 'Review / Completion',
                        labelStyle: 'fw-semibold',
                        fields: [
                                   {
                                       type: 'ProviderSignOff',
                                       col: 'col-12',
                                       fields: [
                                               { label: 'Signature PIN',placeholder:'Signature PIN', name: 'provider_pin', col: 'col-12' },
                                               { label: 'Signature', type: 'NewSignature', name: 'provider_signature', col: 'col-12' },
                                               { label: 'Date', type: 'Date', name: 'signed_date', col: 'col-12' },
                                               // Previous options:
                                               // { label : "Final Results", type: "SelectList", name: "status", col: "col-12",options:isSet(props.lookupsOptions['chartResult'],[]), statusBasedColor: true },
                                               // { label : "Activity Status", type: "SelectList", name: "activity_status", col: "col-12", options: optionsToKeyValuePairs(['Not Started','Ordered','Completed','Cancelled']), statusBasedColor: true },
                                               // New standard options:
                                               { 
                                                 label : "Final Results", 
                                                 type: "SelectList", 
                                                 name: "status", 
                                                 col: "col-12",
                                                 options: optionsToKeyValuePairs(
                                                   [
                                                     "Not Started",
                                                     "Pending",
                                                     "Normal",
                                                     "Abnormal",
                                                     "Negative",
                                                     "Positive",
                                                     "Dispensed",
                                                     "Administered",
                                                     "Failed",
                                                     "Passed",
                                                     "Non-Negative",
                                                     "Cancelled",
                                                     "Inconclusive",
                                                   ],
                                                   false
                                                 ),
                                                 statusBasedColor: true 
                                               },
                                               { 
                                                 label : "Activity Status", 
                                                 type: "SelectList", 
                                                 name: "activity_status", 
                                                 col: "col-12", 
                                                 options: optionsToKeyValuePairs(
                                                   [
                                                     "Not Started",
                                                     "Pending",
                                                     "Pending Lab Confirmation",
                                                     "Pending MRO Confirmation",
                                                     "Ready for Review",
                                                     "Completed",
                                                     "Cancelled",
                                                   ],
                                                   false
                                                 ),
                                                 statusBasedColor: true 
                                               },
                                        ],
                                    },
                                 ],
                        }
                ]
            },
            {
                id:'Images',
                label:'Images',
                data:[]
            }
        ]
    }];
    const defaultValue = {
        status:'Not Started',
        suggested_status:'Not Started',
        activity_status:'Not Started',
        blood_pressure_result:'Not Started',
        ekg_findings_result:'Not Started',
        };
    const headers = [];
    return {
        charts,
        defaultValue,
        headers,
        computationFunction: (formData,key) => ({
            ...computationRules(formData,key),
            ...computationRules1(formData,key),
        }),
    };
}
const computationRules = (formData,key)=>{
    let returnResult = {};
    
    // EKG Findings Result
    returnResult.ekg_findings_result = 'Not Started';
    if(formData.findings === 'Normal / No acute abnormality'){
        returnResult.ekg_findings_result = 'Normal';
    }else if(formData.findings === 'Abnormal / Acute abnormality'){
        returnResult.ekg_findings_result = 'Abnormal';
    }else if(formData.findings === 'Fracture - undisplaced'){
        returnResult.ekg_findings_result = 'Abnormal';
    }else if(formData.findings === 'Fracture - displaced'){
        returnResult.ekg_findings_result = 'Abnormal';
    }else if(formData.findings === 'Dislocation'){
        returnResult.ekg_findings_result = 'Abnormal';
    }else if(formData.findings === 'Effusion'){
        returnResult.ekg_findings_result = 'Abnormal';
    }else if(formData.findings === 'Degenerative changes / arthritis'){
        returnResult.ekg_findings_result = 'Abnormal';
    }else if(formData.findings === 'Foreign body present'){
        returnResult.ekg_findings_result = 'Abnormal';
    }else if(formData.findings === 'Other (specify)'){
        returnResult.ekg_findings_result = 'Abnormal';
    }
    
    // Blood Pressure Result
    const bloodPressure = isSet(formData.blood_pressure_mmhg, '');
    let bloodPressureResult = 'Not Started';
    if(bloodPressure === ''){
        bloodPressureResult = 'Not Started';
    }else if(bloodPressure < 0 || bloodPressure > 139){
        bloodPressureResult = 'Abnormal';
    }else{
        bloodPressureResult = 'Normal';
    }
    returnResult.blood_pressure_result = bloodPressureResult;
    
    return returnResult;
    

  
}